export const history = {
    navigate: null,
    location: null,
    dispatch: null
};